/**
 * Grid de vídeos — Histórias e depoimentos (sem carrossel).
 */
(function () {
  function pauseOthers(currentVideo) {
    document.querySelectorAll('.video-testimonials[data-vt-layout="stories_grid"] video').forEach(function (video) {
      if (video === currentVideo) return;
      video.pause();
      var card = video.closest('[data-vt-grid-card]');
      if (!card) return;
      card.classList.remove('is-playing');
      card.classList.add('is-cover-visible');
      var playBtn = card.querySelector('[data-play]');
      if (playBtn) playBtn.classList.remove('is-hidden');
    });
  }

  function syncPoster(card, playing) {
    if (playing) {
      card.classList.add('is-playing');
      card.classList.remove('is-cover-visible');
    } else {
      card.classList.remove('is-playing');
      card.classList.add('is-cover-visible');
    }
  }

  function initCard(card) {
    var video = card.querySelector('video');
    var playBtn = card.querySelector('[data-play]');
    var muteBtn = card.querySelector('[data-mute]');
    if (!video || !playBtn) return;

    card.classList.add('is-cover-visible');

    playBtn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      if (video.paused) {
        pauseOthers(video);
        video.muted = !(muteBtn && muteBtn.classList.contains('is-unmuted'));
        video.playsInline = true;
        video.play().catch(function () {});
        playBtn.classList.add('is-hidden');
        syncPoster(card, true);
      } else {
        video.pause();
        playBtn.classList.remove('is-hidden');
        syncPoster(card, false);
      }
    });

    video.addEventListener('pause', function () {
      playBtn.classList.remove('is-hidden');
      syncPoster(card, false);
    });

    if (muteBtn) {
      muteBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var unmuted = muteBtn.classList.toggle('is-unmuted');
        video.muted = !unmuted;
        muteBtn.setAttribute('aria-pressed', unmuted ? 'true' : 'false');
        muteBtn.setAttribute(
          'aria-label',
          unmuted ? muteBtn.dataset.labelMute : muteBtn.dataset.labelUnmute
        );
      });
    }
  }

  function boot() {
    document
      .querySelectorAll('.video-testimonials[data-vt-layout="stories_grid"] [data-vt-grid-card]')
      .forEach(initCard);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
